export default "__VITE_ASSET__DkjpY4hQ__"